// メインのJavaScriptファイル
import './navigation.js';

// ここにJavaScriptコードを記述
document.addEventListener('DOMContentLoaded', () => {
  console.log('K&C Theme loaded!');
});
